import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "HERO_FINANCE",
  title: defineMessage({ id: "fig.finance.HERO.title", defaultMessage: `Finance` }),
  caption: defineMessage({
    id: "fig.finance.HERO.caption",
    defaultMessage: `Globally, more than one in four countries spend less than 4% of GDP and less than 15% of total government expenditure on education, the two minimum financing benchmarks.`,
  }),
  source: defineMessage({ id: "fig.finance.HERO.source", defaultMessage: `UIS database` }),
};
